import React from "react";

// import logo from "./logo.svg";
// import "./App.css";
import "./assetsWeb/css/customStyle.css";
import "./assets/css/bootstrap-datetimepicker.min.css";
import "./assets/css/bootstrap.min.css";
// import "./assets/css/ckeditor.css";
import "./assets/css/feather.css";
import "./assets/css/select2.min.css";
import "./assets/css/style.css";
import "./assets/css/login.css";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminStores from "./pages/AdminStores";
import AdminOrderPage from "./pages/AdminOrderPage";
import AdminDriversPage from "./pages/AdminDriversPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminCategories from "./pages/AdminCategories";
import AdminSubCategories from "./pages/AdminSubCategories";
import AdminItemsPage from "./pages/AdminItemsPage";
import "@fortawesome/fontawesome-free/css/all.min.css";
import AdminCities from "./pages/AdminCities";
import AdminAllPayments from "./pages/AdminAllPayments";
import AdminReferral from "./pages/AdminReferral";
import AdminLanguages from "./pages/AdminLanguages";
import AdminContactForm from "./pages/AdminContactForm";
import AdminStoreRequest from "./pages/AdminStoreRequest";
import AdminDriverRequest from "./pages/AdminDriverRequest";
import AdminBanner from "./pages/AdminBanner";
import AdminOffer from "./pages/AdminOffer";
import LoginPage from "./pages/LoginPage";
import AdminNotificationPage from "./pages/AdminNotificationPage";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import AdminOrderDetailPage from "./pages/AdminOrderDetailPage";
import AdminUserDetailPage from "./pages/AdminUserDetailPage";
import AdminStoreDetailPage from "./pages/AdminStoreDetailPage";
import HomePageNew from "./pages/HomePageNew";
import StoreAdminDashboard from "./pages/StoreAdminDashboard";
import StoreAdminItemsPage from "./pages/StoreAdminItemsPage";
import StoreAdminReviewPage from "./pages/StoreAdminReviewPage";
import StoreAdminCreateItemsModal from "./components/storeAdminComponents/StoreAdminCreateItemsModal";
import HomeViewAllPage from "./pages/HomeViewAllPage";
import HomeCheckoutPage from "./pages/HomeCheckoutPage";
import HomeSignUpPage from "./pages/HomeSignUpPage";
import HomeOrderConfirm from "./pages/HomeOrderConfirm";
import HomeAllFoods from "./pages/HomeAllFoods";
import HomeStopDetails from "./pages/HomeStopDetails";
import Unauthorized from "./pages/Unauthorized";

const App = () => {
  const auth = useSelector((state) => state.auth);
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<HomePageNew />} />
        {/* <Route path="/all" element={<HomeViewAllPage />} /> */}
        <Route path="/food" element={<HomeAllFoods />} />
        <Route path="/shop-details/:id" element={<HomeStopDetails />} />
        <Route path="/shop-details" element={<HomeStopDetails />} />
        <Route path="/checkout" element={<HomeCheckoutPage />} />
        <Route path="/sign-up" element={<HomeSignUpPage />} />
        <Route path="/login" element={<LoginPage />} />
        {/* <Route path="/customer-login" element={<LoginCustPage />} /> */}
        {/* <Route path="/admin" element={<LoginPage />} /> */}
        {auth && auth.user && auth.user.role === "user" && (
          <>
            <Route path="/" element={<HomePageNew />} />
            {/* <Route path="/all" element={<HomeViewAllPage />} /> */}
            <Route path="/checkout" element={<HomeCheckoutPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/order-confirm" element={<HomeOrderConfirm />} />
          </>
        )}
        {auth && auth.user && auth.user.role === "superAdmin" && (
          <>
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/cities" element={<AdminCities />} />
            <Route path="/shops" element={<AdminStores />} />
            <Route
              path="/store-details/:id"
              element={<AdminStoreDetailPage />}
            />
            <Route path="/customers" element={<AdminUsersPage />} />
            <Route path="/user-details/:id" element={<AdminUserDetailPage />} />
            <Route path="/drivers" element={<AdminDriversPage />} />
            <Route path="/orders" element={<AdminOrderPage />} />
            <Route
              path="/order-details/:id"
              element={<AdminOrderDetailPage />}
            />
            <Route path="/categories" element={<AdminCategories />} />
            <Route path="/subcategories" element={<AdminSubCategories />} />
            <Route path="/products" element={<AdminItemsPage />} />
            <Route
              path="/create-product"
              element={<StoreAdminCreateItemsModal />}
            />
            <Route path="/all-payments" element={<AdminAllPayments />} />
            <Route path="/referral" element={<AdminReferral />} />
            <Route path="/languages" element={<AdminLanguages />} />
            <Route path="/contact-forms" element={<AdminContactForm />} />
            <Route path="/store-request" element={<AdminStoreRequest />} />
            <Route path="/driver-request" element={<AdminDriverRequest />} />
            <Route path="/banners" element={<AdminBanner />} />
            <Route path="/offers" element={<AdminOffer />} />
            <Route path="/notifications" element={<AdminNotificationPage />} />
            <Route path="/send-mail" element={<AdminDashboard />} />
            <Route path="/support" element={<AdminDashboard />} />
            <Route path="/stats" element={<AdminDashboard />} />
            <Route path="/complaints" element={<AdminDashboard />} />
            <Route path="/general" element={<AdminDashboard />} />
            <Route path="/settings" element={<AdminDashboard />} />
            <Route path="/pages" element={<AdminDashboard />} />
            <Route path="/manage-app" element={<AdminDashboard />} />
            <Route path="/manage-popup" element={<AdminDashboard />} />
            <Route path="/app-updates" element={<AdminDashboard />} />
            <Route path="/administrator" element={<AdminDashboard />} />
            <Route path="/address" element={<AdminDashboard />} />
            <Route path="/buy-now" element={<AdminDashboard />} />
          </>
        )}
        {auth && auth.user && auth.user.role === "admin" && (
          <>
            <Route path="/dashboard" element={<StoreAdminDashboard />} />
            <Route path="/orders" element={<AdminOrderPage />} />
            <Route
              path="/order-details/:id"
              element={<AdminOrderDetailPage />}
            />
            <Route path="/products" element={<StoreAdminItemsPage />} />
            <Route
              path="/create-product"
              element={<StoreAdminCreateItemsModal />}
            />
            <Route path="/reviews" element={<StoreAdminReviewPage />} />
            <Route path="/support" element={<AdminDashboard />} />
            <Route path="/stats" element={<StoreAdminDashboard />} />
            <Route path="/settings" element={<StoreAdminDashboard />} />
            <Route path="/analytics" element={<StoreAdminDashboard />} />
          </>
        )}
        <Route path="*" element={<Unauthorized />} />
        {/* <Route path="*" element={<Unauthorized />} /> */}
      </Routes>
    </>
  );
};

export default App;
